export type ButtonType = 'button' | 'submit' | 'reset';
export type ButtonSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type ButtonLoadingMode =
	| 'off'
	| 'hide-content'
	| 'left-content'
	| 'right-content';

export const baseButtonClass = `
relative
inline-flex
justify-center
items-center
leading-none
outline-none
rounded-full 
text-center
font-bold`;

export const buttonSizeClasses: Record<ButtonSize, string> = {
	xxs: 'px-2.5 py-1 text-callout h-[1.875rem]',
	xs: 'px-3 py-2 text-callout h-[2.125rem]',
	sm: 'px-4 py-2.5 text-callout h-[2.375rem]',
	md: 'px-4 py-2.5 text-body h-[2.625rem]',
	lg: 'px-6 py-3 text-body h-[3.125rem]',
	xl: 'px-7 py-4 text-label h-[3.5rem]'
};
